.facet-container {
  width: 100%;
}
